export default function formatTimeFromSeconds(value: number, format: "short" | "long") {
  if (value === 0) {
    return "-";
  }

  const hours = Math.floor(value / 3600);
  const minutes = Math.floor((value / 3600 - hours) * 60);
  const seconds = Math.floor((value / 60 - Math.floor(value / 60)) * 60);

  if (format === "long") {
    return `${hours}hrs${minutes}m`;
  }

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  if (hours > 0) {
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  return `${formattedMinutes}:${formattedSeconds}`;
}
